import { Injectable } from '@angular/core';

/**
 * è¿æ»¤æ¡ä»¶æå¡
 * @scope FormModule
 */
@Injectable()
class FilterService {

  /**
   * ç§»é¤åå«ç¹æ®å¼çè¿æ»¤æ¡ä»¶
   * @todoï¼åå®filtersä¸ºå­ç¬¦ä¸²ï¼å¾è®¾è®¡æ¶æ¯ææ°ç»åæ°åä¸èµ·è°æ´
   */
  public stripFiltersWithSpecialValue(filters: string, specialValues: string): string {
    if (!filters || !specialValues) {
      return filters;
    }

    const filterArray: any[] = JSON.parse(filters);
    const strippedFilterArray = filterArray.filter((filter: any) => {
      const filterValue = this.getFilterValue(filter);
      return specialValues.indexOf(filterValue) === -1;
    });

    return JSON.stringify(strippedFilterArray);
  }

  /**
   * è·åè¿æ»¤æ¡ä»¶çå¼
   * @todoï¼æ²¡æFilteræ¥å£å®ä¹ï¼ç®åäº§åé¨å¤§å°åä¸ä¸è´ã
   */
  private getFilterValue(filter: any) {
    return filter.Value || filter.value;
  }
}

export { FilterService };
